import { render, staticRenderFns } from "./ConfirmRemovePaymentMethod.vue?vue&type=template&id=4e225513&scoped=true&"
import script from "./ConfirmRemovePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ConfirmRemovePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRemovePaymentMethod.vue?vue&type=style&index=0&id=4e225513&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e225513",
  null
  
)

export default component.exports